import { useState } from "react";
import { useForm } from "react-hook-form";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import CrossIcon from "../../../components/Icons/CrossIcon";

export default function AddWfhModal({ isOpen, toggle, editData, refreshData }) {
  const [loader, setLoader] = useState(false);
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: editData || {}
  });

  const onSubmit = async (data) => {
    try {
      setLoader(true);
      const formData = new FormData();
      formData.append("startDate", data.startDate);
      formData.append("endDate", data.endDate);
      formData.append("reason", data.reason || "");
      if (data.file && data.file[0]) {
        formData.append("file", data.file[0]);
      }

      const res = await callApi(apiUrl.create_wfh, { method: "POST", form_data: formData });
      setLoader(false);
      if (res?.statuscode === 201 || res?.statuscode === 200 || res?.status === true) {
        toast.success(res?.message || "WFH request submitted successfully");
        reset();
        toggle();
        if (refreshData) refreshData();
      } else {
        toast.error(res?.message || "Failed to submit WFH request");
      }
    } catch (err) {
      setLoader(false);
      toast.error(err?.message || "Error submitting WFH request");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle} close={<button className="border-0 bg-transparent" onClick={toggle}><CrossIcon /></button>}>
        Apply Work From Home (WFH)
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">Start Date *</label>
              <input type="date" className="form-control" {...register("startDate", { required: "Start date is required" })} />
              {errors.startDate && <div className="text-danger form-text">{errors.startDate.message}</div>}
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">End Date *</label>
              <input type="date" className="form-control" {...register("endDate", { required: "End date is required" })} />
              {errors.endDate && <div className="text-danger form-text">{errors.endDate.message}</div>}
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Reason *</label>
              <textarea className="form-control" rows={3} placeholder="Enter reason for WFH..." {...register("reason", { required: "Reason is required" })} />
              {errors.reason && <div className="text-danger form-text">{errors.reason.message}</div>}
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Attachment (Optional)</label>
              <input type="file" className="form-control" {...register("file")} />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button type="button" className="btn btn-secondary" onClick={toggle}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loader}>
              {loader ? <Spinner size="sm" /> : "Submit Request"}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
